import {GbBase} from './gb-base';

export class GbNavigation extends GbBase {
  getUrl() {
    return {
     navigate: this.getBaseUrl() + 'gbaccount-navigation-service/navigation/v1/navigate?' + this.getClientId('auth'),
    };
  }
}
